import axios from 'axios';

export default function setup() {

  //$eventBus = vueInstance;
  
  axios.interceptors.request.use(function (config) {
/*
    if (isTokenExpired(Vue.prototype.$token)) {      
      // Make sure to do the AJAX GET call asynchronously
       new Promise((resolve, reject) => {
        $.ajax({
          url: '/Token/RefreshToken',  // Example URL
          type: 'GET',
          success: (response) => {
            // You can modify the request or handle the response if needed
            console.log('AJAX Success:', response);
            if (isTokenExpired(response)) {
              //resolve();
              //alert("Some backend issue so kindly logout and login again.")
            } else {
              Vue.prototype.$token = response;
            }
            resolve();
          },
          error: (err) => {
            // Handle any error
            console.error('AJAX Error:', err);
            reject();
          }
        });
      });
    }
    */
    /*
    const token = store.getters.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    */
    //alert(Vue.prototype.$token);
    //config.headers.push()
    if (config != null && config.url != null && config.url != '' && config.url.toLowerCase().indexOf("/api") == 0) {
      console.log('Axios interceptor => config.url: ', config.url);
      config.url = Vue.prototype.$hostname + config.url;
      console.log('Axios interceptor => config.url: ', config.url);
      if (config.headers != null) {
        config.headers.Authorization = 'Bearer ' + Vue.prototype.$token;//$token;
        config.headers['Cache-Control'] = 'no-cache'
        config.headers['Pragma'] = 'no-cache'
        config.headers['x-siteid'] = Vue.prototype.$site
        config.headers['Accept-Language'] = Vue.prototype.$culture
        /*config.headers['Expires'] = '0'*/
      }
    }
   
    /*
    config.headers = {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Content-Type': 'application/json',
      "Accept": "application/json"
    };*/   
    return config;
  }, function (err) {
    return Promise.reject(err);
  });

  /*
  axios.interceptors.request.use(function (config) {
    const token = store.getters.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }, function (err) {
    return Promise.reject(err);
  });
  */

  // Response interceptor for API calls
  axios.interceptors.response.use((response) => {
    
    return response
  }, async function (error) {
      const originalRequest = error.config;
      
      if (error.response.status === 401) {
        window.$eventBus.$emit('refresh_login_site');
      }
    //if (error.response.status === 403 && !originalRequest._retry) {
      //originalRequest._retry = true;
      //const access_token = await refreshAccessToken();
      //axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
      //return axios(originalRequest);
      
    //}
    return Promise.reject(error);
  });
}



// WEBPACK FOOTER //
// ./src/interceptors.js